export function preParsePostFormat(string) {
    return string;
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/locale/pre-post-format.js
// module id = 1359
// module chunks = 3